import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { ListItemsContext } from '../list-items-context'

import colorsOptions from '../../../../fundamentals/colors-styles/constants'

import {
  ContainerContentListItem,
  ListItemContainerTop,
  ContentColumnIconConfirm,
  ContentColumnActionRight,
  DividerItens
} from '../../styled-components'
import { Confirm } from '../../../../atoms/icons/essentials'

import { badgeColorOptions } from '../../../../atoms/badges/constants'
import {
  listItemStateStyleVariantOptions,
  listItemStateVariantOptions
} from '../../constants'

import { progressBarVariantOptions } from '../../../../atoms/progress-bar/constants'

import { IsLoading } from '../list-items-item'

import { DateTime } from 'luxon'

import CenterContainerMeta from './center-container-meta'
import CenterContainerBadgesAndSwitch from './center-container-badges-and-switch'
import CenterContainerMainContent from './center-container-main-content'
import CenterContainerProgressBar from './center-container-progress-bar'

const CenterContainerItem = ({
  state,
  stateStyle,
  itemKey,
  id,
  date,
  title,
  titleStyle,
  secondaryText,
  tertiaryText,
  badge,
  switchControl,
  metaData,
  textRightValue,
  progressBarControl,
  confirmIconIsShow,
  actionRight,
  loading
}) => {
  const { listViewType, lastItemKey, dividerFull, hideDivider } =
    useContext(ListItemsContext)

  const { isShow, checked, onChange } = switchControl || {}
  const { meta, metaRightBottom } = metaData || {}
  const { label, color: badgeColor } = badge || {}

  const stroke = loading
    ? colorsOptions.greys['grey-20']
    : stateStyle.iconsColor

  const actionRightByState =
    actionRight && (state === listItemStateVariantOptions.INACTIVE || loading)
      ? React.cloneElement(actionRight, { stroke })
      : actionRight

  return (
    <DividerItens
      listViewVariant={listViewType}
      isLastItem={lastItemKey === itemKey}
      hideDivider={hideDivider}
      dividerFull={!dividerFull}
    >
      <ContainerContentListItem>
        <ListItemContainerTop>
          <CenterContainerMainContent
            id={id}
            date={date}
            title={title}
            titleStyle={titleStyle}
            secondaryText={secondaryText}
            tertiaryText={tertiaryText}
            style={listItemStateStyleVariantOptions[state]}
            listViewType={listViewType}
          />
          <CenterContainerBadgesAndSwitch
            badgeValue={label}
            badgesColor={badgeColor}
            switchIsShow={isShow}
            switchIsChecked={checked}
            onChangeSwitch={onChange}
            state={state}
            stateStyle={stateStyle}
          />
          <CenterContainerMeta
            meta={meta}
            textRightValue={textRightValue}
            metaRightBottom={metaRightBottom}
            style={listItemStateStyleVariantOptions[state]}
          />
        </ListItemContainerTop>

        <CenterContainerProgressBar
          progressBarControl={progressBarControl}
          listViewType={listViewType}
          state={state}
        />
      </ContainerContentListItem>
      {confirmIconIsShow && (
        <ContentColumnIconConfirm>
          <IsLoading skeletonStyle={{ width: '32px', height: '32px' }}>
            <Confirm size="icon-s" stroke={stateStyle.iconsColor} />
          </IsLoading>
        </ContentColumnIconConfirm>
      )}
      {actionRightByState && (
        <ContentColumnActionRight>
          {actionRightByState}
        </ContentColumnActionRight>
      )}
    </DividerItens>
  )
}

CenterContainerItem.propTypes = {
  state: PropTypes.oneOf(Object.values(listItemStateVariantOptions)),
  stateStyle: PropTypes.object,
  itemKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  date: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.instanceOf(DateTime)
  ]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  secondaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tertiaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  badge: PropTypes.shape({
    label: PropTypes.string,
    color: PropTypes.oneOf(badgeColorOptions)
  }),
  switchControl: PropTypes.shape({
    isShow: PropTypes.bool,
    checked: PropTypes.bool,
    onChange: PropTypes.func
  }),
  metaData: PropTypes.shape({
    meta: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    metaRightBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  }),
  progressBarControl: PropTypes.shape({
    number: PropTypes.number,
    variant: PropTypes.oneOf(Object.values(progressBarVariantOptions)),
    loading: PropTypes.bool,
    cancelButton: PropTypes.bool,
    onChange: PropTypes.func
  }),
  textRightValue: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  confirmIconIsShow: PropTypes.bool,
  actionRight: PropTypes.node,
  loading: PropTypes.bool
}

export default CenterContainerItem
